export default function SkipLink() {
  return (
    <a href="#main" data-testid="skip-link" className="skip-link">
      Skip to content
    </a>
  );
}
